export default __webpack_public_path__ + "static/Revscale-c52341878481623adb07f6a51b59e3ef.svg";